export const fontSize = 10;

export const fontColor = 'rgba(255, 255, 255, 0.8)';

export const fontFamily = '';

export const getLegend = (data = null, type = 'line') => {
  let global = {};
  let custom = {};
  if (data) {
    global = {
      show: true,
      textStyle: {
        color: fontColor,
        fontStyle: 'normal',
        fontWeight: 'normal ',
        fontFamily: fontFamily,
        fontSize: fontSize,
        lineHeight: '',
        backgroundColor: 'transparent',
        borderColor: '',
        borderWidth: '',
      },
    };
    if (type == 'bar') custom = {
      borderColor: '#ffffff',
      data: data,
    }
    if (type == 'line') custom = {

    }
    if (type == 'pie') custom = {
      orient: 'vertical',
      left: 'left',
    }
  } else {
    return null;
  }
  return { ...global, ...custom };
}

export const getTooltip = (data = null, type = 'line') => {
  let global = {};
  let custom = {};
  if (data) {
    global = { // 提示框全局配置
      show: true,
      trigger: 'item',
      axisPointer: {},
      showContent: true,
      alwaysShowContent: false,
      triggerOn: 'mousemove|click',
      showDelay: 0,
      hideDelay: 100,
      enterable: false,
      renderMode: 'html',
      confine: false,
      appendToBody: false,
      className: '',
      transitionDuration: 0.4,
      // position: [],
      // formatter: ({ name }) => name,
      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: '#333',
      borderWidth: 0,
      padding: 4,
      textStyle: {
        color: fontColor, // 提示框字体颜色
        fontStyle: 'fontStyle',
        fontWeight: 'normal',
        fontFamily: fontFamily,
        fontSize: 8,
        lineHeight: NaN,
        width: NaN,
        height: NaN,
        textBorderColor: '',
        textBorderWidth: NaN,
        textBorderType: 'solid',
        textBorderDashOffset: 0,
        textShadowColor: 'transparent',
        textShadowBlur: 0,
        textShadowOffsetX: 0,
        textShadowOffsetY: 0,
        overflow: 'none',
        ellipsis: '',
        lineOverflow: 'none',
      },
    }
    if (type == 'bar') custom = {
      type: 'category',
      boundaryGap: true,
      data: data,
    }
    if (type == 'line') custom = {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    }
    if (type == 'pie') custom = {
      trigger: 'item'
    }
  }
  return { ...global, ...custom };
}

export const getXaxis = (xAxis = [], type = 'line') => {
  let global = {};
  let custom = {};
  if (xAxis.length > 0) {
    global = {
      type: 'category',
      data: xAxis,
      splitLine: {
        show: false, // 是否显示分割线
      }
    }
    if (type == 'line') custom = {
      boundaryGap: false,
    }
    if (type == 'bar') custom = {
      type: 'category',
      boundaryGap: true,
    }
  }
  return { ...global, ...custom };
}

export const getYaxis = () => {
  let result = [];
  result = [
    {
      type: 'value',
      splitLine: {
        show: false, // 是否显示分割线
      }
    }
  ]
  return result;
}

// 设置多种不同的自定义透明度颜色(取模值)
export function setAreaColor(index = 0, count = 10) {
  return (`rgba(77, 107, 141, 0.${(index % count) + 2})`);
  // return (`rgba(0, 0, 0, 0.${(index % count)})`);
}

// 全局标签配置
export const labelConfig = () => ({
  show: true, // 是否显示标签。
  position: 'top', // 标签的位置。
  distance: 5, // 距离图形元素的距离。
  rotate: 0, // 标签旋转(从 -90 度到 90 度。正值是逆时针)。
  offset: [], // 是否对文字进行偏移。默认不偏移(例如：[30, 40] 表示文字在横向上偏移 30，纵向上偏移 40)。
  formatter: () => null, // 标签内容格式器，支持字符串模板和回调函数两种形式，字符串模板与回调函数返回的字符串均支持用 \n 换行。
  color: 'rgba(255, 255, 255, 0.8)', // 文字的颜色(如果设置为 'inherit'，则为视觉映射得到的颜色，如系列色)。
  fontStyle: 'normal', // 文字字体的风格。
  fontWeight: 'normal', // 文字字体的粗细。
  fontFamily: fontFamily, // 文字的字体系列
  fontSize: fontSize, // 文字的字体大小。
  align: 'auto', // 文字水平对齐方式，默认自动。
  verticalAlign: 'auto', // 文字垂直对齐方式，默认自动。
  lineHeight: 'auto', // 行高。
  backgroundColor: 'transparent', // 文字块背景色。
  borderColor: '', // 文字块边框颜色(如果设置为 'inherit'，则为视觉映射得到的颜色，如系列色)。
  borderWidth: 0, // 文字块边框宽度。
  borderType: 'solid', // 文字块边框描边类型(可选：'solid' 'dashed' 'dotted')。
  borderDashOffset: 0, // 用于设置虚线的偏移量，可搭配 borderType 指定 dash array 实现灵活的虚线效果。
  borderRadius: 0, // 文字块的圆角。
  padding: 0, // 文字块的内边距(例如：padding: [3, 4, 5, 6]：表示 [上, 右, 下, 左] 的边距)。
  shadowColor: 'transparent', // 文字块的背景阴影颜色。
  shadowBlur: 0, // 文字块的背景阴影长度。
  shadowOffsetX: 0, // 文字块的背景阴影 X 偏移。
  shadowOffsetY: 0, // 文字块的背景阴影 Y 偏移。
  width: '', // 文本显示宽度。
  height: '', // 文本显示高度。
  textBorderColor: '', // 文字本身的描边颜色(如果设置为 'inherit'，则为视觉映射得到的颜色，如系列色)。
  textBorderWidth: '', // 文字本身的描边宽度。
  textBorderType: 'solid', // 文字本身的描边类型(可选：'solid' 'dashed' 'dotted')。
  textBorderDashOffset: 0, // 用于设置虚线的偏移量，可搭配 textBorderType 指定 dash array 实现灵活的虚线效果。
  textShadowColor: 'transparent', // 文字本身的阴影颜色。
  textShadowBlur: 0, // 文字本身的阴影长度。
  textShadowOffsetX: 0, // 文字本身的阴影 X 偏移。
  textShadowOffsetY: 0, // 文字本身的阴影 Y 偏移。
  overflow: 'none', // 文字超出宽度是否截断或者换行。配置width时有效('truncate' 截断，并在末尾显示ellipsis配置的文本，默认为..., 'break' 换行, 'breakAll' 换行，跟'break'不同的是，在英语等拉丁文中，'breakAll'还会强制单词内换行)。
  ellipsis: '', // 在overflow配置为'truncate'的时候，可以通过该属性配置末尾显示的文本。
  lineOverflow: 'none', // 文本超出高度部分是否截断，配置height时有效('truncate' 在文本行数超出高度部分截断)。
  rich: {}, // 在 rich 里面，可以自定义富文本样式。利用富文本样式，可以在标签中做出非常丰富的效果(配置查看官网)。
});

export const labelLineConfig = () => ({
  show: true, // 是否显示视觉引导线。
  showAbove: false, // 是否显示在图形上方。
  length2: 0,// 视觉引导项第二段的长度。
  smooth: false, // 是否平滑视觉引导线，默认不平滑，可以设置成 true 平滑显示，也可以设置为 0 到 1 的值，表示平滑程度。
  minTurnAngle: 0, // 通过调整第二段线的长度，限制引导线两端之间最小的夹角，以防止过小的夹角导致显示不美观(可以设置为 0 - 180 度)。
  lineStyle: {
    color: "#000", // 线的颜色。
    width: 1, // 线宽。
    type: 'solid', // 线的类型(可选 'solid' 'dashed' 'dotted')。
    dashOffset: 0, // (从 v5.0.0 开始支持) 用于设置虚线的偏移量，可搭配 type 指定 dash array 实现灵活的虚线效果。
    cap: 'butt', // (从 v5.0.0 开始支持) 用于指定线段末端的绘制方式，可以是 ('butt': 线段末端以方形结束。'round': 线段末端以圆形结束。'square': 线段末端以方形结束，但是增加了一个宽度和线段相同，高度是线段厚度一半的矩形区域)。
    join: 'bevel', // (从 v5.0.0 开始支持) 用于设置2个长度不为0的相连部分（线段，圆弧，曲线）如何连接在一起的属性（长度为0的变形部分，其指定的末端和控制点在同一位置，会被忽略）(可以是：'bevel': 在相连部分的末端填充一个额外的以三角形为底的区域， 每个部分都有各自独立的矩形拐角。'round': 通过填充一个额外的，圆心在相连部分末端的扇形，绘制拐角的形状。 圆角的半径是线段的宽度。'miter': 通过延伸相连部分的外边缘，使其相交于一点，形成一个额外的菱形区域。这个设置可以通过 miterLimit 属性看到效果。)。
    miterLimit: 10, // (从 v5.0.0 开始支持) 用于设置斜接面限制比例。只有当 join 为 miter 时， miterLimit 才有效。默认值为 10。负数、0、Infinity 和 NaN 均会被忽略。
    shadowBlur: 10, // 图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
    shadowColor: '', // 阴影颜色。支持的格式同color。
    shadowOffsetX: 0, // 阴影水平方向上的偏移距离。
    shadowOffsetY: 0, // 阴影垂直方向上的偏移距离。
    opacity: 1, // 图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
  },
});

export const itemStyleConfig = () => ({
  color: '', // 柱条的颜色(默认自适应)。
  borderColor: '#000', // 柱条的描边颜色。
  borderWidth: 0, // 柱条的描边宽度，默认不描边。
  borderType: 'solid', // 柱条的描边类型，默认为实线，支持 'dashed', 'dotted'。
  borderRadius: 0, // 圆角半径，单位px，支持传入数组分别指定 4 个圆角半径。 如: borderRadius: 5, // 统一设置四个角的圆角大小 borderRadius: [5, 5, 0, 0] //（顺时针左上，右上，右下，左下）
  shadowBlur: 10, // 图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
  shadowColor: '', // 阴影颜色。支持的格式同color。
  shadowOffsetX: 0, // 阴影水平方向上的偏移距离。
  shadowOffsetY: 0, // 阴影垂直方向上的偏移距离。
  opacity: 1, // 图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
  decal: {
    symbol: 'rect', // 贴花的图案，如果是 string[] 表示循环使用数组中的图案。 ECharts 提供的标记类型包括('circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none') 可以通过 'image://url' 设置为图片，其中 URL 为图片的链接，或者 dataURI。
    symbolSize: 1, // 取值范围：0 到 1，表示占图案区域的百分比。
    symbolKeepAspect: true, // 是否保持图案的长宽比。
    color: 'rgba(0, 0, 0, 0.2)', // 贴花图案的颜色，建议使用半透明色，这样能叠加在系列本身的颜色上。
    backgroundColor: '', // 贴花的背景色，将会覆盖在系列本身颜色之上，贴花图案之下。
    dashArrayX: 5, // (array) 贴花图案的基本模式是在横向和纵向上分别以图案 - 空白 - 图案 - 空白 - 图案 - 空白的形式无限循环。通过设置每个图案和空白的长度，可以实现复杂的图案效果。
    dashArrayY: 5, // (array) 贴花图案的基本模式是在横向和纵向上分别以图案 - 空白 - 图案 - 空白 - 图案 - 空白的形式无限循环。通过设置每个图案和空白的长度，可以实现复杂的图案效果。
    rotation: 0, // 图案的整体旋转角度（弧度制），取值范围从 -Math.PI 到 Math.PI。
    maxTileWidth: 512, // 生成的图案在未重复之前的宽度上限。通常不需要设置该值，当你发现图案在重复的时候出现不连续的接缝时，可以尝试提高该值。
    maxTileHeight: 512, // 生成的图案在未重复之前的高度上限。通常不需要设置该值，当你发现图案在重复的时候出现不连续的接缝时，可以尝试提高该值。
  },
});

export const emphasisConfig = () => ({
  focus: 'none', // (从 v5.0.0 开始支持) 在高亮图形时，是否淡出其它数据的图形已达到聚焦的效果。支持如下配置：'none' 不淡出其它图形，默认使用该配置。'self' 只聚焦（不淡出）当前高亮的数据的图形。'series' 聚焦当前高亮的数据所在的系列的所有图形。
  blurScope: 'coordinateSystem', // (从 v5.0.0 开始支持) 在开启focus的时候，可以通过blurScope配置淡出的范围。支持如下配置 'coordinateSystem' 淡出范围为坐标系，默认使用该配置。'series' 淡出范围为系列。'global' 淡出范围为全局。
  label: labelLineConfig(), // 图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等。
  labelLine: labelLineConfig(), // 标签的视觉引导线配置。
  itemStyle: itemStyleConfig(), // 图形样式。
});

export function formatRegions(area = null, borderColor = '#3d98b1') {
  let result = [];
  if (area) {
    const { features } = area;
    if (features && features.length > 0) {
      result = features.map(({ properties }, b) => ({
        id: properties.adcode || b,
        name: properties.name,
        selected: false,
        value: 0,
        itemStyle: {
          normal: { // 默认未选中的样式
            // areaColor: setAreaColor(b),
            // color: setAreaColor(b),
            // borderColor: '#0b54ff',
            // borderWidth: 0,
            borderColor: '#1b6776',
            borderWidth: 1,
            borderType: 'solid',
            borderDashOffset: 0,
            borderCap: 'butt',
            borderJoin: 'bevel',
            borderMiterLimit: 10,
            // shadowBlur: 10, // 图形本身的阴影长度。
            // shadowColor: 'rgba(0, 0, 0, 0.8)', // 图形本身的阴影颜色。
            // shadowOffsetX: -10, // 图形本身的阴影 X 偏移。
            // shadowOffsetY: 10, // 图形本身的阴影 Y 偏移。
            opacity: 1,
          },
          emphasis: { // 悬浮或选中的样式
            areaColor: '#2591ff',
          },
        },
        label: {
          normal: () => labelConfig(), // 默认未选中的样式(调用全局标签配置)
          emphasis: { // 悬浮或选中的样式
          },
        },
        ...properties,
      }));
    }
  }
  return result;
}

export function setGeo(name = '', data = [], areaColor = '#07a1fe', borderColor = '#0b54ff') {
  let result = {};
  if (name != '') {
    result = { // 这个是重点配置区
      zoom: 1.2,
      type: 'map',
      name: name,
      map: name, // 地图区域的拼音名称
      roam: true, // 是否开启鼠标缩放和平移漫游(可选'scale' 仅缩放, 'move' 仅平移, true 同时设置平移和缩放)
      regions: data,   // 对不同的区块进行着色
      label: {
        normal: { // 默认样式
          show: true, // 是否显示对应地名
          textStyle: {
            fontSize: 14,
            color: '#ffffff',
          },
          // formatter: ({ name }) => formatNames(name),
        },
        emphasis: { // (悬浮选中样式)对应的鼠标悬浮效果
          show: true,
          textStyle: {
            color: "#ffffff",
          }
        }
      },
      itemStyle: {
        normal: {
          // areaColor: '#2591ff',
          // borderColor: borderColor,
        },
      },
      animation: true,
      animationDurationUpdate: 500,
      animationEasingUpdate: 'cubicOut',
    }
  }
  return result;
}

export function setGeo3D(name = '', regions = [], areaColor = '#07a1fe', borderColor = '#0b54ff') {
  let result = {};
  if (name != '') {
    result = { // 这个是重点配置区
      name, // 地图名称
      map: name, // 地图区域的拼音名称
      show: true,
      roam: true, // 是否开启鼠标缩放和平移漫游(可选'scale' 仅缩放, 'move' 仅平移, true 同时设置平移和缩放)
      regions: regions.map((a) => { // 对不同的区块进行着色
        let region = ({
          ...a,
          regionHeight: 2,
          label: {
            show: true,
            distance: 2,
            formatter: '{b}: {c}',
            textStyle: {
              color: '#fff',
              borderWidth: '1',
              borderColor: 'rgba(0, 0, 0, 0.4)',
              fontFamily,
              fontSize,
              fontWeight: 'normal',
            },
          },
          itemStyle: {
            color: a.color || null,
            opacity: 1,
            borderWidth: 1,
            borderColor: 'rgba(0, 0, 0, 0.4)',
          },
          emphasis: {
            itemStyle: {
              color: a.color || null,
              opacity: 1,
              borderWidth: 1,
              borderColor: 'rgba(0, 0, 0, 0.4)',
            },
            label: {
              show: true,
              distance: 2,
              textStyle: {
                color: '#fff',
                borderWidth: '1',
                borderColor: 'rgba(0, 0, 0, 0.4)',
                fontFamily,
                fontSize,
                fontWeight: 'normal',
              },
            }
          },
          shading: 'lambert', // 可选(color, lambert, realistic)
        });
        return region;
      }),
      label: {
        normal: { // 默认样式
          show: true, // 是否显示对应地名
          textStyle: {
            fontSize: 14,
            color: '#ffffff',
          },
          // formatter: ({ name }) => formatNames(name),
        },
        emphasis: { // (悬浮选中样式)对应的鼠标悬浮效果
          show: true,
          textStyle: {
            color: "#ffffff",
          }
        }
      },
      itemStyle: {
        normal: {
          // areaColor: '#2591ff',
          borderColor,
        },
      },
      animation: true,
      animationDurationUpdate: 500,
      animationEasingUpdate: 'cubicOut',
    }
  }
  return result;
}

export const planeIcon = 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z';

export function convert(data = [], adcode = '', reverse = true) { // 格式化航线数据
  let result = [];
  if (data && data.length > 0) {
    let from = null; // 出发点对象
    let to = []; // 结束点对象集合
    for (let a = 0; a < data.length; a++) {
      if (data[a].center && data[a].center.length > 1) {
        if (adcode != '') { // 是否传入邮编号码
          if (data[a].adcode == adcode) {
            from = data[a];
          } else {
            from = data[0];
            to.push(data[a]);
          }
        } else { // 没有传入邮编号码 则使用第一个对象作为出发点
          form = data[0];
          to.push(data[a + 1]);
        }
      }
    }
    if (from && to.length > 0) {
      for (let a = 0; a < to.length; a++) {
        result.push({ // (reverse) 是否反转航线
          fromName: reverse ? to[a].name : from.name,
          toName: reverse ? from.name : to[a].name,
          coords: reverse ? [to[a].center, from.center] : [from.center, to[a].center],
        });
      }
    }
  }
  return result;
}

export function setLines(data = [], adcode = '430100', symbolSize = 14, color = '#46bee9', period = 3) { // 飞机航线
  let result = [];
  if (data.length > 0) {
    result = [
      {
        type: 'lines', // 用于带有起点和终点信息的线数据的绘制，主要用于地图上的航线，路线的可视化。
        zlevel: 100,
        effect: { // 线特效的配置
          show: true,
          period: period, // 特效动画的时间
          trailLength: 0.7, // 特效尾迹的长度。取从 0 到 1 的值，数值越大尾迹越长。
          color: '#fff', // 线路颜色
          symbolSize: symbolSize / 2, // 特效标记的大小，可以设置成诸如 10 这样单一的数字，也可以用数组分开表示高和宽，例如 [20, 10] 表示标记宽为20，高为10。
        },
        lineStyle: {
          normal: {
            color: color,
            width: 0,
            curveness: 0.1, // 边的曲度，支持从 0 到 1 的值，值越大曲度越大
          }
        },
        data: convert(data, adcode),
      },
      {
        type: 'lines',
        zlevel: 101,
        symbol: ['none', 'arrow'],// 线两端的标记类型，可以是一个数组分别指定两端
        symbolSize: symbolSize,
        effect: {
          show: true,
          period: period, // 特效动画的时间
          trailLength: 0,
          symbol: planeIcon, // 飞机图标
          color: color, // 飞机颜色
          symbolSize: symbolSize * 2,
        },
        lineStyle: {
          color: color,
          width: 1,
          opacity: 0.6,
          curveness: 0.1
        },
        data: convert(data, adcode),
      },
    ]
  }
  return result;
}

export function setScatterMain(data = [], adcode = '', color = 'orange') { // 过滤掉数组中起点或者结束对象
  let result = [];
  if (data && data.length > 0) {
    for (let a = 0; a < data.length; a++) {
      if ((adcode && adcode == data[a].adcode) || (adcode && adcode.includes(data[a].adcode))) {
        result.push({
          ...data[a],
          value: data[a].center ? [data[a].center[0], data[a].center[1]] : [],
          label: {
            emphasis: {
              position: 'right',
              show: false,
            },
          },
          itemStyle: {
            normal: {
              color: color, // 起点或者聚焦点对象集合颜色
            }
          }
        });
      }
    }
  }
  return result;
};

export function setScatterElse(data = [], adcode = '', color = '#15d36a') {
  let result = [];
  if (data && data.length > 0) {
    for (let a = 0; a < data.length; a++) {
      if (!adcode || adcode != data[a].adcode || !adcode.includes(data[a].adcode)) {
        result.push({
          ...data[a],
          value: data[a].center ? [data[a].center[0], data[a].center[1]] : [],
          label: {
            emphasis: {
              position: 'right',
              show: false,
            },
          },
          itemStyle: {
            normal: {
              color: color, // 起点集合或者聚焦点对象颜色
            }
          },
        });
      }
    }
  }
  return result;
}

export function setScatter(data = [], adcode = '', extra = [], type = 'effectScatter', size = 6, period = 8) {
  let result = [];
  let global = {};
  if (data && data.length > 0) {
    global = { // 通用配置
      type: type,
      symbol: 'circle',
      rippleEffect: type == 'effectScatter' && { // 设置涟漪动画样式
        // color:'purple',  // 涟漪颜色,默认为散点自身颜色
        // brushType:'fill' // 动画方式,全填充或只有线条,'stroke'
        period: period,  // 动画周期
        scale: size * 1.3,  // 涟漪规模
        brushType: 'stroke', // 波纹绘制方式, 可选('stroke', 'fill');
      },
      symbolSize: () => size,
      coordinateSystem: 'geo',
      itemStyle: {
        normal: {
          color: '#dd5145',
          shadowColor: '#000000',
        },
      },
      zlevel: 1000,
      label: { // 图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
        show: false,
        position: 'right',
        formatter: '{b}'
      },
    };
    result = [
      {
        ...global, // 聚焦点对象样式配置
        rippleEffect: type == 'effectScatter' && { // 设置涟漪动画样式
          // color:'purple',  // 涟漪颜色,默认为散点自身颜色
          // brushType:'fill' // 动画方式,全填充或只有线条,'stroke'
          period: period,  // 动画周期
          scale: size * 2,  // 涟漪规模
          brushType: 'stroke'
        },
        data: setScatterMain(data, adcode), // 设置站点集合,
      },
      { // 分散点对象集合样式设置(除了起始位置对象 其他站点对象设置)
        ...global,
        data: setScatterElse(data, adcode), // 设置站点集合,
      },
      ...extra, // 额外的配置
    ];
  }
  return result;
}

const iconsMain = require('./icon/site9.png');

const iconsElse = require('./icon/site10.png');

export function setIcons(data = [], adcode = '', extra = [], type = 'scatter', size = 36) {
  let result = [];
  let global = {};
  if (data && data.length > 0) {
    global = { // 通用配置
      type: type,
      // symbol: `image://${iconsMain}`,
      symbolSize: () => size,
      coordinateSystem: 'geo',
      itemStyle: {
        normal: {
          color: '#dd5145',
          shadowColor: '#000000',
        },
      },
      zlevel: 10000,
      label: { // 图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
        show: false,
        position: 'right',
        formatter: '{b}'
      },
    };
    result = [
      {
        ...global, // 聚焦点对象样式配置
        symbol: `image://${iconsMain}`,
        symbolSize: () => size * 1.2,
        data: setScatterMain(data, adcode), // 设置站点集合,
      },
      { // 分散点对象集合样式设置(除了起始位置对象 其他站点对象设置)
        ...global,
        symbol: `image://${iconsElse}`,
        data: setScatterElse(data, adcode), // 设置站点集合,
      },
      ...extra, // 额外的配置
    ];
  }
  return result;
}

export const viewControl = ({
  projection: 'orthographic',
  autoRotate: false,
  autoRotateDirection: 'ccw',
  autoRotateSpeed: 10,
  autoRotateAfterStill: 3,
  damping: 0.8,
  rotateSensitivity: 0,
  zoomSensitivity: 1,
  panSensitivity: 1,
  panMouseButton: 'left',
  rotateMouseButton: 'middle',
  distance: 100,
  minDistance: 60,
  maxDistance: 60,
  orthographicSize: 60,
  maxOrthographicSize: 60,
  minOrthographicSize: 60,
  alpha: 40,
  beta: 0,
  center: [0, 0, 0],
  minAlpha: 5,
  maxAlpha: 90,
  minBeta: -80,
  maxBeta: 80,
  animation: true,
  animationDurationUpdate: 1000,
  animationEasingUpdate: 'cubicInOut',
});

export const setMap3D = (name = '', data = []) => {
  let result = {};
  if (name != '') {
    result = {
      type: 'map3D', // map、map3D
      map: name, // 注册的地图名称
      boxWidth: 60, // 三维地理坐标系组件在三维场景中的宽度
      boxHeight: 10, // 三维地理坐标系组件在三维场景中的高度
      boxDepth: 76, // 三维地理坐标系组件在三维场景中的深度
      regionHeight: 2, // 三维地图区域高度
      environment: 'auto',
      groundPlane: { // 地面背景
        show: false,
        color: '#aaaaaa',
      },
      label: {
        show: true, // 是否显示对应地名
        distance: 3,
        formatter: ({ name, status }) => name,
        textStyle: {
          color: '#000',
          borderWidth: 0,
          // borderColor: '#ffffff',
          fontFamily: fontFamily,
          fontSize: 14,
          fontWeight: 'normal',
        },
      },
      itemStyle: {
        color: '#07a1fe',
        opacity: 1,
        borderWidth: 1,
        borderColor: '#0b54ff',
      },
      emphasis: {
        label: {
          show: true,
          distance: 2,
          formatter: ({ name, status }) => name,
          textStyle: {
            color: '#000',
            borderWidth: 1,
            borderColor: '#000',
            fontFamily: fontFamily,
            fontSize: 20,
            fontWeight: 'normal',
          },
        },
        itemStyle: {
          color: 'orange',
          opacity: 1,
        },
      },
      viewControl,
      data,
    }
  }
  return result;
}

export function setScatter3D(data = []) {
  let global = {};
  let result = {};
  if (data.length > 0) {
    global = {
      type: 'scatter3D',
      name: 'scatter3D',
      coordinateSystem: 'cartesian3D',
      grid3DIndex: 0,
      geo3DIndex: 0,
      globeIndex: 0,
      symbol: 'circle',
      symbolSize: 10,
      itemStyle: {
        color: '#fff',
        opacity: 0.8,
        borderWidth: 0,
        borderColor: '#fff',
      },
      label: {
        show: true,
        distance: 5,
        position: 'right',
        // formatter: ({ name }) => name,
        textStyle: {
          color: '#000',
          borderWidth: 1,
          borderColor: '#fff',
          fontFamily: 'sans-serif',
          fontSize: 14,
          fontWeight: 'normal ',
        },
      },
      emphasis: {
        itemStyle: {
          color: '',
          opacity: 0.8,
          borderWidth: 0,
          borderColor: '#fff',
        },
        label: {
          show: true,
          distance: 5,
          position: 'right',
          // formatter: ({ name }) => name,
          textStyle: {
            color: '#000',
            borderWidth: 1,
            borderColor: '#fff',
            fontFamily: 'sans-serif',
            fontSize: 14,
            fontWeight: 'normal',
          },
        },
      },
      data: [
        [[12, 14, 10], [34, 50, 15], [56, 30, 20], [10, 15, 12], [23, 10, 14]]
      ],
      blendMode: 'source-over',
      zlevel: -10,
      silent: false,
      animation: true,
      animationDurationUpdate: 500,
      animationEasingUpdate: 'cubicOut'
    }
  }
  return { ...global, ...custom };
}

export const setLine = (data = [], type = 'line') => {
  let global = {};
  let custom = {};
  if (data && data.length) {
    global = {
      type: type,
      id: '',
      name: '',
      coordinateSystem: 'cartesian2d',
      xAxisIndex: 0,
      yAxisIndex: 0,
      polarIndex: 0,
      symbol: 'emptyCircle',
      symbolSize: 4,
      symbolRotate: '',
      symbolKeepAspect: false,
      symbolOffset: [0, 0],
      showSymbol: true,
      showAllSymbol: 'auto',
      legendHoverLink: true,
      stack: '',
      cursor: 'pointer',
      connectNulls: false,
      clip: true,
      step: false,
      label: '',
      endLabel: '',
      labelLine: '',
      labelLayout: '',
      itemStyle: '',
      lineStyle: '',
      areaStyle: '',
      emphasis: '',
      blur: '',
      select: '',
      selectedMode: false,
      smooth: false,
      smoothMonotone: '',
      sampling: '',
      dimensions: '',
      encode: '',
      seriesLayoutBy: 'column',
      datasetIndex: 0,
      data: data,
      markPoint: '',
      markLine: '',
      markArea: '',
      zlevel: 0,
      z: 2,
      silent: false,
      animation: true,
      animationThreshold: 2000,
      animationDuration: 1000,
      animationEasing: linear,
      animationDelay: 0,
      animationDurationUpdate: 300,
      animationEasingUpdate: cubicInOut,
      animationDelayUpdate: 0,
      tooltip: '',
    }
  }
  return { ...global, ...custom };
};

export const setBar = (data = [], type = 'bar') => {
  let global = {};
  let custom = {};
  if (data && data.length > 0) {
    global = {
      type: 'bar',
      id: '', // 组件 ID。默认不指定。指定则可用于在 option 或者 API 中引用组件。
      name: '', // 系列名称，用于tooltip的显示，legend 的图例筛选，在 setOption 更新数据和配置项时用于指定对应的系列。
      legendHoverLink: true, // 是否启用图例 hover 时的联动高亮。
      coordinateSystem: 'cartesian2d', // 使用二维的直角坐标系（也称笛卡尔坐标系），通过 xAxisIndex, yAxisIndex指定相应的坐标轴组件。
      xAxisIndex: 0, // 使用的 x 轴的 index，在单个图表实例中存在多个 x 轴的时候有用。
      yAxisIndex: 0, // 使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用。
      roundCap: false, // 是否在环形柱条两侧使用圆弧效果。仅对极坐标系柱状图有效。
      showBackground: false, // 是否显示柱条的背景色。通过 backgroundStyle 配置背景样式。
      backgroundStyle: { // 每一个柱条的背景样式。需要将 showBackground 设置为 true 时才有效。
        color: 'rgba(180, 180, 180, 0.2)', // 柱条的颜色。
        borderColor: '#000', // 柱条的描边颜色。
        borderWidth: 0, // 柱条的描边宽度，默认不描边。
        borderType: 'solid', // 柱条的描边类型，默认为实线，支持 'dashed', 'dotted'。
        borderRadius: 0, // number Array 圆角半径，单位px，支持传入数组分别指定 4 个圆角半径。 如: borderRadius: 5, // 统一设置四个角的圆角大小 borderRadius: [5, 5, 0, 0] //（顺时针左上，右上，右下，左下）
        shadowBlur: 0, // 图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
        shadowColor: '', // 阴影颜色。支持的格式同color。
        shadowOffsetX: 0, // 阴影水平方向上的偏移距离。
        shadowOffsetY: 0, // 阴影垂直方向上的偏移距离。
        opacity: 1, // 图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
      },
      label: labelConfig(),
      labelLine: labelLineConfig(),
      itemStyle: itemStyleConfig(),
      labelLayout: {
        hideOverlap: false, // 是否隐藏重叠的标签。
        moveOverlap: '', // 在标签重叠的时候是否挪动标签位置以防止重叠。'shiftX' 水平方向依次位移，在水平方向对齐时使用 'shiftY' 垂直方向依次位移，在垂直方向对齐时使用
        x: '', // (number string) 标签的 x 位置。支持绝对的像素值或者'20%'这样的相对值。
        y: '', // (number string) 标签的 y 位置。支持绝对的像素值或者'20%'这样的相对值。
        dx: '', // (number) 标签在 x 方向上的像素偏移。可以和x一起使用。
        dy: '', // (number) 标签在 y 方向上的像素偏移。可以和y一起使用。
        rotate: '', // (number) 标签旋转角度。
        width: '', // (number) 标签显示的宽度。可以配合overflow使用控制标签显示在固定宽度内。
        height: '', // (number) 标签显示的高度。可以配合lineOverflow使用控制标签显示在固定高度内。
        align: '', // (string) 标签水平对齐方式。可以设置'left', 'center', 'right'。
        verticalAlign: '', // (string) 标签垂直对齐方式。可以设置'top', 'middle', 'bottom'。
        fontSize: '', // (number) The text size of the label.
        draggable: true, // 标签是否可以允许用户通过拖拽二次调整位置。
        labelLinePoints: [], // (Array) 标签引导线三个点的位置。格式为：[[x, y], [x, y], [x, y]] 在饼图中常用来微调已经计算好的引导线，其它情况一般不建议设置。
      },
      emphasis: emphasisConfig(),
      blur: { // 淡出时的图形样式和标签样式。开启 emphasis.focus 后有效。
        label: labelLineConfig(),
        labelLine: labelLineConfig(),
        itemStyle: itemStyleConfig(),
      },
      select: { // 数据选中时的图形样式和标签样式。开启 selectedMode 后有效。
        label: labelLineConfig(),
        labelLine: labelLineConfig(),
        itemStyle: itemStyleConfig(),
      },
      selectedMode: false,
      stack: '',
      sampling: '',
      cursor: 'pointer',
      barWidth: '自适应',
      barMaxWidth: '',
      barMinWidth: '',
      barMinHeight: 0,
      barMinAngle: 0,
      barGap: '30%',
      barCategoryGap: '20%',
      large: false,
      largeThreshold: 400,
      progressive: 5000,
      progressiveThreshold: 3000,
      progressiveChunkMode: 'mod',
      dimensions: '',
      encode: '',
      seriesLayoutBy: 'column',
      datasetIndex: 0,
      data: data, // 传入数据
      clip: true,
      zlevel: 0,
      z: 2,
      silent: false,
      animation: true,
      animationThreshold: 2000,
      animationDuration: 1000,
      animationEasing: 'cubicOut',
      animationDelay: 0,
      animationDurationUpdate: 300,
      animationEasingUpdate: 'cubicInOut',
      animationDelayUpdate: 0,
    }
  }
  return { ...global, ...custom };
}

// 生成随机数据集合
export const randomData = () => {
  now = new Date(+now + oneDay);
  value = value + Math.random() * 21 - 10;
  return {
    name: now.toString(),
    value: [
      [now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'),
      Math.round(value)
    ]
  };
}

// 解析地图数据(地图专用)
export const toScatter = (regions) => {
  // if (features) {
  //   const toCoordinates = () => {
  //     if (features && features.length > 0) {
  //       const array = [];
  //       for (let a in features) {
  //         array.push({ coordinates: features[a].geometry.coordinates, ...features[a].properties })
  //       }
  //       return array;
  //     }
  //   }
  //   const coordinates = toCoordinates();
  //   return features && features.length > 0 && features.map((item, index) => {
  //     return {
  //       type: 'scatter',
  //       symbol: 'circle',
  //       symbolSize: () => 14,
  //       coordinateSystem: 'geo',
  //       itemStyle: {
  //         normal: {
  //           color: '#00eaea',
  //           shadowColor: '#aaaaaa',
  //         },
  //       },
  //       zlevel: 100,
  //       data: coordinates.map(a => {
  //         return {
  //           name: a.name,
  //           value: [...a.coordinates, 0],
  //           label: {
  //             emphasis: {
  //               position: 'right',
  //               show: false
  //             }
  //           },
  //           itemStyle: {
  //             normal: {
  //               color: a.color
  //             }
  //           }
  //         };
  //       })
  //     }
  //   });
  // }
}

export const linearColor = (begin = '#53c9d3', final = '#53b3ff') => {
  return {
    type: 'linear', // 线性渐变
    x: 0,
    y: 1,
    x2: 0,
    y2: 0,
    colorStops: [
      {
        offset: 0,
        color: begin // 0%处的颜色为红色
      },
      {
        offset: 1,
        color: final // 100%处的颜色为蓝
      }
    ]
  }
}